module.exports = __webpack_public_path__ + "img/4.33d1ecb4.png";